//import { push } from 'react-router-redux'
import {push} from '../lib/history'
//import uuid from 'uuid'
import {axios, API, LANGUAGES, BASE} from '../../config'
import {find, release, refreshPage, actions as pageActions, clearCache} from './page'
import {entityTypes} from '../conf/entityAdmin'
import getBlockInfo from '../admin/BlockInfo'

const types = {
	TOGGLE_DESIGN_MODE: 'TOGGLE_DESIGN_MODE',
	PAGE_DIALOG: 'PAGE_DIALOG',
	MENUS_DIALOG: 'MENUS_DIALOG',
	ENTITY_DIALOG: 'ENTITY_DIALOG',
	BLOCK_DIALOG: 'BLOCK_DIALOG',
	BLOCK_LAYOUT_DIALOG: 'BLOCK_LAYOUT_DIALOG',
	STYLE_DIALOG: 'STYLE_DIALOG',
	CONFIRM_DIALOG: 'CONFIRM_DIALOG',
	DIALOG_CANCEL: 'DIALOG_CANCEL',
	OPEN_DIALOG: 'OPEN_DIALOG',
	EDIT_MODE: 'EDIT_MODE',
	EDIT_CANCEL: 'EDIT_CANCEL',
	
	EDIT_BLOCK_TEXT: 'EDIT_BLOCK_TEXT',
	EDIT_BLOCK: 'EDIT_BLOCK',
	TOGGLE_EDIT_BLOCK: 'TOGGLE_EDIT_BLOCK',
	EDIT_BLOCK_SAVE: 'EDIT_BLOCK_SAVE',
	DELETE_BLOCK: 'DELETE_BLOCK',
	DELETE_ELEMENT: 'DELETE_ELEMENT',
	SAVE_DATA: 'SAVE_DATA',
	SAVED_DATA: 'SAVED_DATA',
	SAVE_STEP: 'SAVE_STEP',

	START_INLINE_EDIT: 'START_INLINE_EDIT',
	END_INLINE_EDIT: 'END_INLINE_EDIT',
	FINISH_SAVE: 'FINISH_SAVE',
	UPDATE_STYLE: 'UPDATE_STYLE',

	VIEW_CONTENT: 'VIEW_CONTENT',
	TOGGLE_VIEW_CONTENT: 'TOGGLE_VIEW_CONTENT',
	HIDE_CONTENT: 'HIDE_CONTENT',
	
	TOGGLE_PROP: 'TOGGLE_PROP',
};

const initialState = {
	saving: false,
	saveStep: -1,
	dialog: null,
	edit: false,
	designMode: false,
	style: null,
	contentVisible: false,
	props: {}
}

export default function adminReducer(state = initialState, action) {
   	//console.log(action);
   	switch(action.type) {
		case types.TOGGLE_DESIGN_MODE:
    		return Object.assign({}, state, {designMode: !state.designMode})
		case types.ENTITY_DIALOG:
    		return Object.assign({}, state, {
    				dialog: {
    					type: 'entity', 
    					data: action.entity,
    					tag: action.tag
    				}})
		case types.DIALOG_CANCEL:
    		return Object.assign({}, state, {dialog: null})


		case types.BLOCK_DIALOG: {
    		return Object.assign({}, state, {
    			dialog: {
    				type: 'block', 
    				data: action.data
    			}
    		})
		}
		case types.STYLE_DIALOG: {
    		return Object.assign({}, state, {
    			dialog: {
    				type: 'style', 
    				data: action.data
    			}
    		})
		}
		case types.BLOCK_LAYOUT_DIALOG: {
    		return Object.assign({}, state, {
    			dialog: {
    				type: 'block-layout', 
    				data: action.data
    			}
    		})
		}
		case types.MENUS_DIALOG: {
    		return Object.assign({}, state, {
    			dialog: {
    				type: 'menus'
    			}
    		})
		}
		case types.CONFIRM_DIALOG: 
			return Object.assign({}, state, {
    			dialog: {
    				type: 'confirm', 
    				data: action.data
    			}
    		})
    		/*
    	case types.EDIT_MODE:
    		return Object.assign({}, state, {edit: action.data})
    	case types.EDIT_CANCEL:
    		return Object.assign({}, state, {edit: null})
    		*/
		case types.SAVE_DATA:
			return Object.assign({}, state, {
        		saving: true,
      		});
		case types.SAVE_STEP:
			return Object.assign({}, state, {
        		saving: true,
        		saveStep: action.step
      		});
		case types.SAVED_DATA:
			return Object.assign({}, state, {
        		saving: false,
        		saveStep: -1
      		});
    	case types.START_INLINE_EDIT:
    		return Object.assign({}, state, {edit: action.data})
    	case types.END_INLINE_EDIT:
    		return Object.assign({}, state, {edit: null})
		case types.FINISH_SAVE:
			return Object.assign({}, state, {saving: false, saveStep: -1});
		case types.UPDATE_STYLE:
			return Object.assign({}, state, {style: action.data});
		case types.VIEW_CONTENT:
			return Object.assign({}, state, {contentVisible: true});
		case types.TOGGLE_VIEW_CONTENT:
			return Object.assign({}, state, {contentVisible: !state.contentVisible});
		case types.HIDE_CONTENT:
			return Object.assign({}, state, {contentVisible: false});

		case types.TOGGLE_PROP:
			const newProps = Object.assign({}, state.props, {[action.prop]: !state.props[action.prop]})
			return Object.assign({}, state, {props: newProps});

		case types.OPEN_DIALOG:
    		return Object.assign({}, state, {
    			dialog: {
    				type: action.dialog, 
    				data: action.data
    			}
    		})
		default:
			return state;
	}
}
const entityEditDialog = (entity, tag=null) => ({ type: types.ENTITY_DIALOG, entity, tag })

const entityNewDialog = (type, data=null) => (dispatch, getState) => {
	let entity = null
    switch(type) {
    	case 'node':
    		entity = {   		
				type: 'node', 
				pathauto: true,
				published: false,
			}
			if (LANGUAGES && LANGUAGES.length>0) {
				entity.path = LANGUAGES.map(lang => ({lang, p:''}))
			} else {
				entity.path = ''
			}
			break
    	default:
			entity ={
   				type
			}
    		break
    }
    if(data) {
    	entity = Object.assign({}, entity, data)
    }
	return dispatch(entityEditDialog(entity))
}

const saveData = () => ({type: types.SAVE_DATA})
const savedData = () => ({type: types.SAVED_DATA})

const save = (update, cb=null) => (dispatch, getState) => {
		let state = getState()
		
		let id
		if(update.id) id = update.id
		else {
			if(update._id) id = update._id['$oid']
			else {
				if (!state.page[state.page.location]) return
				id = state.page[state.page.location].data[0]._id['$oid']
			}
		}
		let collection = update.collection?update.collection:'node'
		
		//console.log(update, id, collection)
		
		dispatch(saveData())
		return axios.put(`${API}/data/${collection}/${id}`, update)
			.then(response => {
				//console.log(response)
				clearCache()
				if(cb) cb(response)
				else dispatch(savedData())
			})
			.catch(error => {
			    //eslint-disable-next-line
			    Bugsnag.notifyException(error)
			    dispatch(pageActions.error(error))
			})
}
const insert = (update, cb=null) => (dispatch, getState) => {
		let collection = update.collection || 'node'
		//console.log(update)
		
		dispatch(saveData())
		return axios.post(`${API}/data/${collection}`, update)
			.then(response => {
				//console.log(response)
				clearCache()
				if(cb) cb(response)
				else dispatch(savedData())
			})
			.catch(error => {
			    //eslint-disable-next-line
			    Bugsnag.notifyException(error)
			    dispatch(pageActions.error(error))
			})
}
const remove = (_id, collection='node', cb=null) => {
	return (dispatch, getState) => {
		let id = _id
		if(id['$oid']) id = id['$oid']
		dispatch(saveData())
		return axios.delete(`${API}/data/${collection}/${id}`)
			.then(response => {
				clearCache()
				if(cb) cb(response)
				else dispatch(savedData())
				if(collection==='node') push('/')
			})
			.catch(error => {
			    //eslint-disable-next-line
			    Bugsnag.notifyException(error)
			    dispatch(pageActions.error(error))
			})
	}
}

const pageEditDialog = () => (dispatch, getState) => {
	let state = getState()
	if(!state.page[state.page.location]) return null
	return dispatch(entityEditDialog(state.page[state.page.location].data[0]))
}

const pageDeleteDialog = () => (dispatch, getState) => {
	let state = getState()
	if (!state.page[state.page.location]) return
	return dispatch({
		type: types.CONFIRM_DIALOG, 
		data: {confirm: 'page-delete', data: state.page[state.page.location].data[0]}
	})
}

const toggleDesignMode = () => (dispatch, getState) => {
	let state = getState()
	if (state.admin.designMode) {
		document.body.classList.remove('design-mode')
	} else {
		document.body.classList.add('design-mode')
	}
	return dispatch({ type: types.TOGGLE_DESIGN_MODE })
}

const startInlineEdit = data => ({ type: types.START_INLINE_EDIT, data})
		
/*
const startInlineEdit = e => {
	console.log(e)
	return { 
		type: types.START_INLINE_EDIT, 
		data: {
			id: e.currentTarget.getAttribute('data-id'),
			collection: e.currentTarget.getAttribute('data-type'),
			uuid: e.currentTarget.getAttribute('data-uuid'),
			field: e.currentTarget.getAttribute('data-field'),
			tag: e.currentTarget.getAttribute('data-refresh-tag') 
		}
	}}
	*/
const endInlineEdit = e => ({ type: types.END_INLINE_EDIT })

const saveStep = step => ({type: types.SAVE_STEP, step})
const finishSave = () => ({ type: types.FINISH_SAVE })

const pageNewDialog = () => entityNewDialog('node', 'page')
const dialogCancel = () => ({ type: types.DIALOG_CANCEL })

const blockNewDialog = (entity=null, block=null) => (dispatch, getState) => {
	let newBlock = {
		type: 'text'
		//uuid: null,
		//p: null,
	}
	if(block) {
		newBlock.p = block.uuid
	}
	let parentEntity = entity
	if (!parentEntity) {
		const state = getState()
		parentEntity = (state.page[state.page.location] && state.page[state.page.location].data)?state.page[state.page.location].data[0]:null
		if (!parentEntity) return
	}
	
	return dispatch({ 
		type: types.BLOCK_DIALOG, 
		data: {
			block: newBlock,
			entity: parentEntity
		} 
	})
}

const blockEditDialog = (entity, block) => ({
	type: types.BLOCK_DIALOG, 
	data: {
		block,
		entity
	} 
})
const styleDialog = (entity, block=null) => ({
	type: types.STYLE_DIALOG, 
	data: {
		block,
		entity
	} 
})

const blockLayoutDialog = (entity, block) => ({
	type: types.BLOCK_LAYOUT_DIALOG, 
	data: {
		block,
		entity
	} 
})

const menusEditDialog = () => ({
	type: types.MENUS_DIALOG, 
	data: {} 
})

const realMoveUp = (entity, block, dispatch, tag=null) => {
	let grid = entity.grid

	let current = -1
	grid.forEach((item, i) => {if(item.uuid===block.uuid) current = i})
	if (current<=0) return
	let parent = grid[current].p
	
	let prev = -1
	for(let i=current-1; i>=0; i--) {
		if(grid[i].p === parent || (!grid[i].p && !parent)) {
			prev = i
			break
		}
	}
	if(prev<0) return
		
	let c = grid[prev]
	grid[prev] = grid[current]
	grid[current] = c
		
	return dispatch(save({
		_id: entity._id,
		collection: entity.type,
		data: {'$set': {grid}}
	}, result => {
		dispatch(finishSave())
		if(tag) dispatch(release(tag))
		dispatch(refreshPage())
	}))
}
const moveUp = (entity, block) => dispatch => {
	if(!LANGUAGES) return realMoveUp(entity, block, dispatch)

	let info = getBlockInfo(block, entity)
	dispatch(find('blockFull', {
		collection: info.collection, 
			query: {
				'_id': entity._id['$oid'], 
			},
			nofilter: true
		}, true, data => {
			if(data.results && data.results.length>0) {
				let fullEntity = data.results[0]
				let fullBlocks = fullEntity.grid.filter(b => b.uuid===block.uuid)
				if(fullBlocks.length>0) {
					let fullBlock = fullBlocks[0]
					return realMoveUp(fullEntity, fullBlock, dispatch, 'blockFull')
				}
			}
		}))
}

const blockDeleteConfirm = (entity, block) => ({
	type: types.CONFIRM_DIALOG, 
	data: {confirm: 'block-delete', entity, block}
})

const entityDeleteConfirm = (entity) => ({
	type: types.CONFIRM_DIALOG, 
	data: {confirm: 'entity-delete', entity}
})

const findFilesRecursive = (entity, files) => {
	if(!entity) return
	if (typeof entity !== 'object') return
	
	if (entity.url) {
		files.push(entity.url)
		return
	}
	if (Array.isArray(entity)) {
		entity.forEach(item => findFilesRecursive(item, files))
		return
	}
	Object.keys(entity).forEach(key => findFilesRecursive(entity[key], files))
}
const findFiles = entity => {
	let files = []
	findFilesRecursive(entity, files)
	return files
}

const confirm = data => dispatch => {
	//console.log(data)
	switch(data.confirm) {
		case 'block-delete': 
			const {entity, block} = data
			const collection = entity.type==='node' 
				? 'node' 
				: ( (entityTypes[entity.type] && entityTypes[entity.type].collection)
					?entityTypes[entity.type].collection
					:entity.type)
			return dispatch(save({
				_id: entity._id,
				collection,
				data: {'$pull': {grid: {uuid: block.uuid}}},
				remove: findFiles(block)
			}, result => {
				dispatch(finishSave())
				dispatch(dialogCancel())
				dispatch(refreshPage())
			}))
		case 'entity-delete': 
			console.log(data)
			return dispatch(remove(data.entity._id, data.entity.type))
		case 'page-delete': 
			return dispatch(remove(data.data._id))
		default:
			return
	}
}
const updateStyle = style => {
	const links = document.getElementsByTagName("link");
	
	for(let i in links) {
		const link = links[i]
		if (!link || !link.getAttribute || 
			link.getAttribute("rel")!=='stylesheet' ||
			link.href.indexOf(BASE)<0) continue
		if (style) link.href = `${BASE}${style}`
	}
}
const viewContent = () => ({type: types.VIEW_CONTENT}) 
const toggleViewContent = () => ({type: types.TOGGLE_VIEW_CONTENT}) 
const hideContent = () => ({type: types.HIDE_CONTENT}) 
const toggleProp = prop => ({type: types.TOGGLE_PROP, prop})
const openDialog = (dialog, data=null) => ({type: types.OPEN_DIALOG, dialog, data})

export {
	toggleDesignMode,
	entityNewDialog, entityEditDialog, entityDeleteConfirm,
	pageNewDialog, pageEditDialog, pageDeleteDialog, 
	blockNewDialog, moveUp, blockEditDialog, blockDeleteConfirm, blockLayoutDialog,
	styleDialog,
	confirm,
	dialogCancel,
	startInlineEdit, endInlineEdit, 
	insert, save, remove, saveStep, finishSave,
	menusEditDialog,
	updateStyle,
	toggleViewContent,
	viewContent,
	hideContent,
	toggleProp,
	openDialog
}



// WEBPACK FOOTER //
// ./src/fm/reducers/admin.js